import { priceMultiply, priceAdd } from '@/utils';

export interface Opt {
  count?: number;
  unitPrice?: number | string;
}
export const getTotalPrice = (opt: Opt) => {
  const { count = 0, unitPrice = 0 } = opt;
  return priceMultiply(count, (Number(unitPrice)));
}

export interface ComboPriceOpt {
  unitPrice?: number | string;
  selectCombo?: any;
}

export const getComboPrice = (opt: ComboPriceOpt) => {
  // 如果没有提供 unitPrice，默认值为 0
  const unitPrice = Number(opt.unitPrice || 0);
  // 如果 selectCombo 为空，直接返回 unitPrice
  if (!opt.selectCombo) {
    return unitPrice;
  }


  let totalAddDishPrice = 0;

  // 遍历 selectCombo 获取所有 addOnPrice 的总和
  opt.selectCombo.forEach((combo: any) => {
    if (combo.dishList) {
      combo.dishList.forEach((dish: any) => {
        let totalPrice = 0;
        const priceMarkup = Number( dish?.originDish?.priceMarkup || 0);
        if (priceMarkup > 0) {
          totalPrice += priceMarkup;
        }
        if (dish.addOnPrice) {
          totalPrice += dish.addOnPrice;
        }
        const count = dish?.count;
        if (count > 0) {
          totalPrice = Number(getTotalPrice({ unitPrice: totalPrice, count }))
        }
        totalAddDishPrice += totalPrice;
      });
    }
  });
  // 计算最终的组合价格
  const totalComboPrice = priceAdd(unitPrice, totalAddDishPrice);
  return Number(totalComboPrice || 0);
}
